"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  Browse: "Parcourir",
  Change: "Changer",
  "Drop your image here": "Déposer votre image ici",
  "Drop your logo here": "Déposer votre logo ici",
  Remove: "Supprimer",
  "Revert to default": "Revenir aux valeurs par défaut",
  "Sorry, \"{fileName}\" is larger than {maxFileSize} and can't be uploaded. Please upload a file that's {maxFileSize} or smaller.": ["Désolés, le fichier « ", ["fileName"], " » ne peut pas être chargé, car sa taille dépasse ", ["maxFileSize"], ". Veuillez charger un fichier de taille égale ou inférieure à ", ["maxFileSize"], "."],
  "Sorry, \"{fileName}\" is smaller than {minFileSize} and can't be uploaded. Please upload a file that's {minFileSize} or larger.": ["Désolés, le fichier « ", ["fileName"], " » ne peut pas être chargé, car sa taille est inférieure à ", ["minFileSize"], ". Veuillez charger un fichier de taille égale ou supérieure à ", ["minFileSize"], "."],
  "Sorry, this image format isn't supported. Please provide a {fileTypes}.": ["Désolé, ce format d’image n’est pas pris en charge. Veuillez fournir un fichier de type ", ["fileTypes"], "."],
  "Unsupported file type": "Type de fichier non pris en charge"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map